import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

let router = new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: resolve =>
        require(["@/framework/pc/views/Home/Home.vue"], resolve),
      meta: { title: "首页", headerType: "index" }
    },
    {
      path: "/product",
      name: "product",
      component: resolve =>
        require(["@/framework/pc/views/Product/Product.vue"], resolve),
      meta: { title: "产品", headerType: "other" }
    },
    {
      path: "/news",
      name: "News",
      component: resolve =>
        require(["@/framework/pc/views/News/News.vue"], resolve),
      meta: { title: "新闻", headerType: "other" }
    },
    {
      path: "/news-details",
      name: "NewsDetails",
      component: resolve =>
        require([
          "@/framework/pc/views/News/components/NewsDetails/NewsDetails.vue"
        ], resolve),
      meta: { title: "新闻-详情", headerType: "other" }
    },
    {
      path: "/about-us",
      name: "AboutUs",
      component: resolve =>
        require(["@/framework/pc/views/AboutUs/AboutUs.vue"], resolve),
      meta: { title: "关于我们", headerType: "other" }
    },
    {
      path: "/contact-us",
      name: "ContactUs",
      component: resolve =>
        require(["@/framework/pc/views/ContactUs/ContactUs.vue"], resolve),
      meta: { title: "联系我们", headerType: "other" }
    }
  ]
});
/**
 * 判断是否为移动设备，是，则跳转到移动端的路径
 */
router.beforeEach((to, from, next) => {
  const isMobile = window.localStorage.getItem("isMobile");
  if (
    /Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent) ||
    isMobile == true
  ) {
    window.location.href = "/m.html#/";
    return;
  }
  window.scrollTo(0, 0);
  next();
});
export default router;
